import { apiService } from "../utils/serviceApi";
import {
  ADD_VEHICLE_TO_PARKING_ZONE_WHITELIST,
  CLOSE_DUPLICATE_WHITELIST_WEHICLE_MODAL,
  DUPLICATE_WHITELIST_WEHICLE,
  GET_ALL_WHITELIST_FOR_PARKING_ZONE,
  REMOVE_VEHICLE_FROM_PARKING_ZONE_WHITELIST,
  SET_LOADER,
} from "./types";

export const getAllWhitelistForParkingZone =
  (parkingZoneId) => async (dispatch) => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    apiService
      .get(
        `${process.env.REACT_APP_SERVICE_URL}/api/whitelist/${parkingZoneId}`
      )
      .then((res) => {
        dispatch({
          type: GET_ALL_WHITELIST_FOR_PARKING_ZONE,
          payload: res.data,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
  };

export const addVehicleToParkingZoneWhitelist =
  (whitelistVehicle, setErrorBlacklistModal, closeModal) =>
  async (dispatch) => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    apiService
      .post(
        `${process.env.REACT_APP_SERVICE_URL}/api/whitelist`,
        whitelistVehicle
      )
      .then((res) => {
        if (res.status === 409) {
          return dispatch({
            type: DUPLICATE_WHITELIST_WEHICLE,
          });
        }
        if (res.status === 403) {
          setErrorBlacklistModal(true);
          return;
        }
        dispatch({
          type: ADD_VEHICLE_TO_PARKING_ZONE_WHITELIST,
          payload: res.data,
        });
        closeModal();
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
  };

export const removeVehicleFromParkingZoneWhitelist =
  (id, closeDeleteModal) => async (dispatch) => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    apiService
      .put(`${process.env.REACT_APP_SERVICE_URL}/api/whitelist/remove/${id}`)
      .then(() => {
        dispatch({
          type: REMOVE_VEHICLE_FROM_PARKING_ZONE_WHITELIST,
          payload: id,
        });
        closeDeleteModal();
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
  };

export const closeDuplicateWhitelistVehicleModal = () => async (dispatch) => {
  dispatch({
    type: CLOSE_DUPLICATE_WHITELIST_WEHICLE_MODAL,
  });
};
